export default __webpack_public_path__ + "static/media/misc-books1-768w.0d63edf5.webp";